import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { TimeoutPopupService } from 'src/app/services/timeout-popup.service';
import { SearchService } from 'src/app/services/search/search.service';
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../config/hotel-tours-list-page.config";

@Component({
  selector: 'app-timeout-popup',
  templateUrl: './timeout-popup.component.html',
  styleUrls: ['./timeout-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimeoutPopupComponent {
  messages: any = {};
  constructor(
    private timeoutPopupService: TimeoutPopupService,
    private searchService: SearchService,
    @Inject(HOTEL_TOURS_PAGE_CONFIG) hotelToursPageConfig: HotelToursPageConfig
  ) {
    this.messages = hotelToursPageConfig.translates.timeOutPopup;
  }

  repeatSearch(): void {
    this.searchService.repeatLastSearch();
    this.timeoutPopupService.close();
  }
}
